(function () {
  'use strict';

  function getData() {
    var el = document.getElementById('dex-mega-solutions-data');
    if (!el) return null;
    try {
      var d = JSON.parse(el.textContent);
      return d.tabs || [];
    } catch (e) { return null; }
  }

  function esc(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildRail(tabs, railEl, activeKey) {
    var html = '';
    tabs.forEach(function (tab) {
      html += '<button class="dex-rail-filter' + (tab.key === activeKey ? ' is-active' : '') +
        '" data-key="' + esc(tab.key) + '">' +
        '<span class="dex-rail-label">' + esc(tab.railLabel) + '</span>' +
        (tab.railCount ? '<span>' + esc(tab.railCount) + '</span>' : '') +
        '</button>';
    });
    railEl.innerHTML = html;
  }

  function renderCenter(centerEl, tab) {
    var html = '';
    html += '<div class="dex-mega-center-head"><div>';
    if (tab.tabHeading) html += '<h2>' + esc(tab.tabHeading) + '</h2>';
    if (tab.tabIntro) html += '<p>' + esc(tab.tabIntro) + '</p>';
    html += '</div>';
    if (tab.viewAllLabel && tab.viewAllUrl) {
      html += '<a href="' + esc(tab.viewAllUrl) + '">' + esc(tab.viewAllLabel) + '</a>';
    }
    html += '</div>';

    var links = tab.links;
    if (links && links.items && links.items.length) {
      var vis = links.items.filter(function (l) { return l.show; });
      if (vis.length) {
        html += '<div class="dex-mega-links"><div class="dex-mega-link-group">';
        if (links.heading) html += '<h3>' + esc(links.heading) + '</h3>';
        var currentPath = window.location.pathname;
        vis.forEach(function (l) {
          var isActive = l.url && l.url === currentPath;
          html += '<a href="' + esc(l.url || '#') + '"' + (isActive ? ' class="dex-mega-link--active"' : '') + '>' + esc(l.label) + '</a>';
        });
        html += '</div></div>';
      }
    }
    centerEl.innerHTML = html;
  }

  function renderPromo(promoEl, tab) {
    var p = tab.promo || {};
    promoEl.setAttribute('data-promo', tab.key);
    promoEl.style.setProperty('--dex-promo-overlay-opacity', p.overlayOpacity != null ? p.overlayOpacity : 45);
    if (p.headingColor) promoEl.style.setProperty('--dex-promo-heading-color', p.headingColor);
    if (p.bodyColor) promoEl.style.setProperty('--dex-promo-body-color', p.bodyColor);

    var html = '';
    if (p.backgroundImage) {
      html += '<img class="dex-promo-bg" src="' + esc(p.backgroundImage) + '" alt="" loading="lazy">';
      promoEl.classList.add('has-promo-image');
    } else {
      promoEl.classList.remove('has-promo-image');
    }
    html += '<div class="dex-promo-copy">';
    if (p.heading) html += '<h2>' + esc(p.heading) + '</h2>';
    if (p.body) html += '<p>' + esc(p.body) + '</p>';
    html += '</div>';
    if (p.show !== false) {
      var hasPrimary = p.showPrimary && p.primaryLabel;
      var hasSecondary = p.showSecondary && p.secondaryLabel;
      if (hasPrimary || hasSecondary) {
        html += '<div class="dex-promo-actions">';
        if (hasPrimary) html += '<a href="' + esc(p.primaryUrl || '#') + '" class="dex-btn dex-btn-primary">' + esc(p.primaryLabel) + '</a>';
        if (hasSecondary) html += '<a href="' + esc(p.secondaryUrl || '#') + '" class="dex-btn dex-btn-secondary">' + esc(p.secondaryLabel) + '</a>';
        html += '</div>';
      }
    }
    promoEl.innerHTML = html;
  }

  function buildMobileDropdown(tabs, dropdownEl) {
    var html = '';
    tabs.forEach(function (tab) {
      var links = tab.links;
      if (!links || !links.items || !links.items.length) return;
      var vis = links.items.filter(function (l) { return l.show; });
      if (!vis.length) return;
      html += '<div class="dex-mobile-group">';
      if (links.heading) html += '<h3>' + esc(links.heading) + '</h3>';
      vis.forEach(function (l) {
        html += '<a href="' + esc(l.url || '#') + '">' + esc(l.label) + '</a>';
      });
      html += '</div>';
    });
    dropdownEl.innerHTML = html;
  }

  function init() {
    var nav = document.querySelector('.dex-nav-v2--b2b');
    if (!nav) return;

    var tabs = getData();
    if (!tabs || !tabs.length) return;

    var railEl = nav.querySelector('[data-bus-rail]');
    var centerEl = nav.querySelector('[data-bus-center]');
    var promoEl = nav.querySelector('[data-bus-promo]');
    var mobileDropdownEl = nav.querySelector('[data-bus-mobile-dropdown]');

    var activeKey = tabs[0].key;

    if (railEl) buildRail(tabs, railEl, activeKey);
    if (centerEl) renderCenter(centerEl, tabs[0]);
    if (promoEl) renderPromo(promoEl, tabs[0]);
    if (mobileDropdownEl) buildMobileDropdown(tabs, mobileDropdownEl);

    if (railEl) {
      var hoverTimer = null;
      var lastHoverKey = null;
      var activateKey = function (key) {
        var tab = null;
        for (var i = 0; i < tabs.length; i++) { if (tabs[i].key === key) { tab = tabs[i]; break; } }
        if (!tab) return;
        activeKey = key;
        railEl.querySelectorAll('.dex-rail-filter').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-key') === key);
        });
        if (centerEl) renderCenter(centerEl, tab);
        if (promoEl) renderPromo(promoEl, tab);
      };
      railEl.addEventListener('mouseover', function (e) {
        var btn = e.target.closest('[data-key]');
        if (!btn) return;
        var k = btn.getAttribute('data-key');
        if (k === lastHoverKey) return;
        lastHoverKey = k;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { activateKey(k); }, 120);
      });
      railEl.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        lastHoverKey = null;
      });
      railEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-key]');
        if (!btn) return;
        clearTimeout(hoverTimer);
        lastHoverKey = null;
        activateKey(btn.getAttribute('data-key'));
      });
    }

    var mobileToggle = nav.querySelector('[data-dex-mobile-toggle]');
    var mobilePanel = nav.querySelector('.dex-mobile-panel');
    if (mobileToggle && mobilePanel) {
      mobileToggle.addEventListener('click', function () {
        var isOpen = mobilePanel.classList.toggle('is-open');
        mobileToggle.setAttribute('aria-expanded', String(isOpen));
        document.documentElement.style.setProperty('--header-height', nav.offsetHeight + 'px');
      });
    }

    var solutionsToggle = nav.querySelector('[data-bus-solutions-toggle]');
    var mobileDropdownDiv = nav.querySelector('[data-bus-mobile-dropdown]');
    if (solutionsToggle && mobileDropdownDiv) {
      solutionsToggle.addEventListener('click', function () {
        var isOpen = mobileDropdownDiv.classList.toggle('is-open');
        solutionsToggle.setAttribute('aria-expanded', String(isOpen));
      });
    }

    function onScroll() { nav.classList.toggle('is-scrolled', window.scrollY > 4); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    document.documentElement.style.setProperty('--header-height', nav.offsetHeight + 'px');
    window.addEventListener('resize', function () {
      document.documentElement.style.setProperty('--header-height', nav.offsetHeight + 'px');
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());